import { EnumEndpoints, EnumEndpointsName, EnumMethod } from "@/constants/app/type";
import { callbackLocationSearch } from "./callbacks/callbackLocationSearch";
import { callbackHotelDetail } from "./callbacks/callbackHotelDetail";
import { callbackFilterOptions } from "./callbacks/callbackFilterOptions";
import { callbackHotelSearch } from "./callbacks/callbackHotelSearch";
import { callbackCities } from "./callbacks/callbackCities";
import { callbackHotelResources } from "./callbacks/callbackHotelResources";
import { EnumAPIKey } from "@/constants/app/api";

export const hotelEnpoints = {
  [EnumEndpointsName.HOTEL_GOOD_PRICES]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_GOOD_PRICES,
    api: EnumAPIKey.API_BASE
  },
  [EnumEndpointsName.HOTEL_MASTER_DETAIL]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_MASTER_DETAIL,
    api: EnumAPIKey.API_BASE
  },
  [EnumEndpointsName.HOTEL_BOOKING_CANCEL]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.HOTEL_BOOKING_CANCEL,
    api: EnumAPIKey.API_HOTEL
  },
  [EnumEndpointsName.HOTEL_DETAIL_REVIEWS]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_DETAIL_REVIEWS,
    api: EnumAPIKey.API_HOTEL
  },
  [EnumEndpointsName.HOTEL_DETAIL_STATISTICS]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_DETAIL_STATISTICS,
    api: EnumAPIKey.API_HOTEL
  },
  [EnumEndpointsName.HOTEL_LOCATIONS_SEARCH]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_LOCATIONS_SEARCH,
    api: EnumAPIKey.API_HOTEL,
    caller: callbackLocationSearch
  },
  [EnumEndpointsName.HOTEL_BOOKING_CONFIRM_CANCEL]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.HOTEL_BOOKING_CONFIRM_CANCEL,
    api: EnumAPIKey.API_HOTEL
  },
  [EnumEndpointsName.HOTEL_DETAIL]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_DETAIL,
    api: EnumAPIKey.API_HOTEL,
    attachRootFields: ["feePolicies"],
    caller: callbackHotelDetail
  },
  [EnumEndpointsName.HOTEL_DETAIL_RESOURCE]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_DETAIL_RESOURCE,
    api: EnumAPIKey.API_HOTEL,
    caller: callbackHotelResources
  },
  [EnumEndpointsName.HOTEL_FILTER_OPTION]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_FILTER_OPTION,
    api: EnumAPIKey.API_HOTEL,
    caller: callbackFilterOptions
  },
  [EnumEndpointsName.HOTEL_SORT_OPTION]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_SORT_OPTION,
    api: EnumAPIKey.API_HOTEL
  },
  [EnumEndpointsName.HOTEL_SEARCH_KEYWORD]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_SEARCH_KEYWORD,
    api: EnumAPIKey.API_HOTEL
  },
  [EnumEndpointsName.HOTEL_SEARCH]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.HOTEL_SEARCH,
    api: EnumAPIKey.API_HOTEL,
    attachRootFields: ["feePolicies"],
    caller: callbackHotelSearch
  },
  [EnumEndpointsName.HOTEL_LOCATIONS_INIT]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.HOTEL_LOCATIONS_INIT,
    api: EnumAPIKey.API_HOTEL
  },
  [EnumEndpointsName.HOTEL_LOCATIONS_POPULAR]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_LOCATIONS_POPULAR,
    api: EnumAPIKey.API_HOTEL
  },
  [EnumEndpointsName.HOTEL_LOCATIONS_DETAIL]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_LOCATIONS_DETAIL,
    api: EnumAPIKey.API_HOTEL
  },
  [EnumEndpointsName.HOTEL_HEALTHZ]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_HEALTHZ,
    api: EnumAPIKey.API_HOTEL
  },
  [EnumEndpointsName.HOTEL_ORDER]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.HOTEL_ORDER,
    api: EnumAPIKey.API_HOTEL
  },
  [EnumEndpointsName.HOTEL_ORDER_PRECHECK]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.HOTEL_ORDER_PRECHECK,
    api: EnumAPIKey.API_HOTEL
  },
  [EnumEndpointsName.HOTEL_CITIES]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_CITIES,
    api: EnumAPIKey.API_HOTEL,
    caller: callbackCities
  },
  [EnumEndpointsName.HOTEL_COUNTRIES]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_COUNTRIES,
    api: EnumAPIKey.API_HOTEL
  },
  [EnumEndpointsName.HOTEL_AREAS]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.HOTEL_AREAS,
    api: EnumAPIKey.API_HOTEL
  },
}